/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillSponsoredAccount} from '../api'

export const useMutationBackfillSponsoredAccount = createReactQueryMutationHook('backfillSponsoredAccount', backfillSponsoredAccount)
